import { type FlagKey, type Flags } from '@core/context/FeatureFlagsContext';
import { type MonarchEditableAsset } from '@core/context/types';

import { type QuestionType } from '../blocks/edu-flow/components/Page/types';
import personalizationQuestionImportantFactors from './assets/personalizationQuestionImportantFactors';
import personalizationQuestionLevelOfEducation from './assets/personalizationQuestionLevelOfEducation';
import personalizationQuestionPursuingHigherEducation from './assets/personalizationQuestionPursuingHigherEducation';
import noPii from './assets/personalizationQuestionZip';
import securityBoost from './assets/securityBoost';

type GenerateAssetFunction = (question: QuestionType, asset: MonarchEditableAsset) => QuestionType;

const assetTypeToGenQuestionMap: Partial<Record<FlagKey, GenerateAssetFunction>> = {
  personalizationQuestionImportantFactors,
  personalizationQuestionLevelOfEducation,
  personalizationQuestionPursuingHigherEducation,
  noPii,
  securityBoost,
};

type TestResults = Record<string, any>;

const generateAssetQuestion = (question: QuestionType, flags: Flags, testResults?: TestResults): QuestionType => {
  if (question?.monarchEditableAssetFlag === undefined) return question;

  // For noPii flag, check testResults instead of flags
  if (question?.monarchEditableAssetFlag === 'noPii') {
    const noPiiTestResult = testResults?.noPii as MonarchEditableAsset;

    if (!noPiiTestResult) return question;

    const generateFunction = assetTypeToGenQuestionMap[question?.monarchEditableAssetFlag];

    if (!generateFunction) {
      console.error(`No asset generation function found for asset: ${question?.monarchEditableAssetFlag}`);
      return question;
    }

    return generateFunction(question, noPiiTestResult);
  }

  // For other flags, use the original logic
  const monarchEditableAsset = flags[question?.monarchEditableAssetFlag as FlagKey] as MonarchEditableAsset;

  if (!monarchEditableAsset) return question;

  const generateFunction = assetTypeToGenQuestionMap[question?.monarchEditableAssetFlag];

  if (!generateFunction) {
    console.error(`No asset generation function found for asset: ${question?.monarchEditableAssetFlag}`);
    return question;
  }

  return generateFunction(question, monarchEditableAsset);
};
export default generateAssetQuestion;
